import { FC } from "react";
import { IconPropsType } from ".";

export const Survey: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15.3333C12.0501 15.3333 15.3333 12.0501 15.3333 8C15.3333 3.94991 12.0501 0.666667 8 0.666667C3.94991 0.666667 0.666667 3.94991 0.666667 8C0.666667 12.0501 3.94991 15.3333 8 15.3333ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill={props.color}
      />
      <path
        d="M7.2405 10.1679C7.24817 9.68041 7.31343 9.28889 7.43625 8.99334C7.56292 8.69778 7.82969 8.34849 8.23656 7.94546C8.64342 7.54243 8.90444 7.25839 9.01959 7.09334C9.13858 6.92445 9.2307 6.74021 9.29595 6.54061C9.3612 6.34102 9.39383 6.11263 9.39383 5.85546C9.39383 5.34112 9.25565 4.93617 8.97928 4.64061C8.70676 4.34506 8.32484 4.19728 7.83353 4.19728C7.33837 4.19728 6.93918 4.3393 6.63595 4.62334C6.33272 4.90738 6.17726 5.2893 6.16959 5.7691H5.43262C5.44029 5.09354 5.66868 4.55233 6.11777 4.14546C6.5707 3.73859 7.14262 3.53516 7.83353 3.53516C8.54363 3.53516 9.10403 3.74243 9.51474 4.15697C9.92545 4.57152 10.1308 5.13384 10.1308 5.84394C10.1308 6.2892 10.0291 6.70758 9.82565 7.0991C9.62221 7.48677 9.23837 7.94162 8.67413 8.46364C8.20969 8.85516 7.97747 9.42324 7.97747 10.1679H7.2405ZM7.14262 12.2349C7.14262 12.0928 7.18676 11.9738 7.27504 11.8779C7.36332 11.7819 7.48807 11.7339 7.64928 11.7339C7.80666 11.7339 7.9314 11.7819 8.02353 11.8779C8.11565 11.9738 8.16171 12.0928 8.16171 12.2349C8.16171 12.3692 8.11565 12.4843 8.02353 12.5803C7.9314 12.6724 7.80666 12.7185 7.64928 12.7185C7.48807 12.7185 7.36332 12.6724 7.27504 12.5803C7.18676 12.4843 7.14262 12.3692 7.14262 12.2349Z"
        fill={props.color}
      />
    </svg>
  );
};
